import React from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import {
  Badge,
  Card,
  CardBody,
  Col,
  Container,
  Row,
} from 'reactstrap';
import { ArrowLeft } from 'react-feather';
import { getCamelCaseWord } from '../static/brands_wholesalers_data';
import UserManagementUsersTab from '../Components/UserManagementUsersTab';
import OrganizationMatches from '../Components/OrganizationMatches';

const OrganizationDetail = () => {
  const { organizationId } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const organization = location.state?.organization;
  const organizationType = organization?.type || 'brand';

  const infoItems = [
    { label: 'Organization ID', value: organization?.id || organizationId },
    { label: 'Name', value: organization?.name || '--' },
    { label: 'Website', value: organization?.website || '--' },
    { label: 'Type', value: getCamelCaseWord(organizationType) },
    { label: 'Premium', value: organization?.is_premium ? 'Yes' : 'No' },
    {
      label: 'Plan',
      value: organization?.plan_details?.name || organization?.plan_details?.provider || '--',
    },
    { label: 'Members', value: organization?.totalMembers ?? '--' },
    { label: 'Contact Credits', value: organization?.contact_credits ?? '--' },
    {
      label: 'Joined Date',
      value: organization?.created_at
        ? new Date(organization.created_at).toLocaleDateString()
        : '--',
    },
    { label: 'Source', value: getCamelCaseWord(organization?.source || '--') },
    { label: 'Referral', value: getCamelCaseWord(organization?.referral || '--') },
  ];

  return (
    <Container fluid style={{ padding: '20px' }}>
      <Row className="mb-3">
        <Col>
          <button
            type="button"
            className="btn btn-link text-decoration-none p-0 mb-3 d-flex align-items-center gap-2"
            onClick={() => navigate(-1)}
          >
            <ArrowLeft size={18} />
            Back to Organizations
          </button>

          <div className="d-flex align-items-center gap-3 flex-wrap">
            <h3 className="mb-0">Organization Details</h3>
            <Badge color="info" className="text-uppercase">
              {getCamelCaseWord(organizationType)}
            </Badge>
          </div>
          {!organization && (
            <p className="text-muted mt-2 mb-0">
              Organization summary was not passed in navigation state. Showing data for ID {organizationId}.
            </p>
          )}
        </Col>
      </Row>

      <Card className="shadow-sm mb-4">
        <CardBody>
          <h5 className="mb-3">Organization Info</h5>
          <Row className="g-3">
            {infoItems.map((item) => (
              <Col key={item.label} xs={12} sm={6} md={4} lg={3}>
                <div
                  className="h-100 p-3 border rounded"
                  style={{ backgroundColor: '#fafafa' }}
                >
                  <small className="text-muted d-block mb-1">{item.label}</small>
                  <div className="fw-semibold text-break">{item.value}</div>
                </div>
              </Col>
            ))}
          </Row>
        </CardBody>
      </Card>

      <OrganizationMatches organizationId={Number(organizationId)} organizationName={organization?.name} />

      <h5 className="mb-3">Users</h5>
      <UserManagementUsersTab
        organizationName={organization?.name}
        embedded
      />
    </Container>
  );
};

export default OrganizationDetail;
